export enum DraftAssetType {
    Cloud = 1,
    OnPrem = 2
}
